"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const cameraRenderGetOnQrCallback_1 = __importDefault(require("../../../shared/cameraRenderGetOnQrCallback"));
const useAppStateSelector_1 = __importDefault(require("../../../hooks/useAppStateSelector"));
const appStateSelectFullScreenCameraOnBarCodeRead_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnBarCodeRead"));
const appStateSelectFullScreenCameraOnQRCodeRead_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnQRCodeRead"));
const appStateSelectFullScreenCameraOnTakePicture_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnTakePicture"));
const appStateSelectFullScreenCameraOnStartRecord_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnStartRecord"));
const appStateSelectFullScreenCameraOnStopRecord_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnStopRecord"));
const appStateSelectFullScreenCameraOnRejectedPermissions_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnRejectedPermissions"));
const useAppStateDispatch_1 = __importDefault(require("../../../hooks/useAppStateDispatch"));
const AppStateConstants_1 = require("../../../types/AppStateConstants");
const appStateSelectFullScreenCameraOnClose_1 = __importDefault(require("../../../shared/appStateSelectFullScreenCameraOnClose"));
const zIndex_1 = __importDefault(require("../../../constants/zIndex"));
// eslint-disable-next-line no-shadow
var CAMERA_MODE;
(function (CAMERA_MODE) {
    CAMERA_MODE[CAMERA_MODE["TAKING_PHOTO"] = 0] = "TAKING_PHOTO";
    CAMERA_MODE[CAMERA_MODE["RECORDING_VIDEO"] = 1] = "RECORDING_VIDEO";
    CAMERA_MODE[CAMERA_MODE["SCANNING_CODE"] = 2] = "SCANNING_CODE";
    CAMERA_MODE[CAMERA_MODE["NO_OPTION"] = 3] = "NO_OPTION";
})(CAMERA_MODE || (CAMERA_MODE = {}));
// eslint-disable-next-line no-shadow
var CAMERA_STATE;
(function (CAMERA_STATE) {
    CAMERA_STATE[CAMERA_STATE["RECORDING"] = 0] = "RECORDING";
    CAMERA_STATE[CAMERA_STATE["READY"] = 1] = "READY";
    CAMERA_STATE[CAMERA_STATE["SCANNING"] = 2] = "SCANNING";
})(CAMERA_STATE || (CAMERA_STATE = {}));
const containerStyle = {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 15,
    height: 'auto',
    backgroundColor: 'gray',
};
const backgroundStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'black',
    zIndex: zIndex_1.default.fullScreenCamera,
};
const frameStyle = {
    flex: 1,
    position: 'relative',
};
const closeButtonStyle = {
    position: 'absolute',
    top: 40,
    right: 40,
};
const cameraStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
};
const CameraFullScreenRenderer = () => {
    const cameraRef = (0, react_1.useRef)(null);
    const { Render } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const [zoom, setZoom] = (0, react_1.useState)(0);
    const [device, setDevice] = (0, react_1.useState)('back');
    const [isTorchOn, setIsTorchOn] = (0, react_1.useState)(false);
    const onBarCodeRead = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnBarCodeRead_1.default);
    const onQRCodeRead = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnQRCodeRead_1.default);
    const onTakePicture = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnTakePicture_1.default);
    const onStartRecord = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnStartRecord_1.default);
    const onStopRecord = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnStopRecord_1.default);
    const onClose = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnClose_1.default);
    // eslint-disable-next-line max-len
    const onRejectedPermissions = (0, useAppStateSelector_1.default)(appStateSelectFullScreenCameraOnRejectedPermissions_1.default);
    const dispatch = (0, useAppStateDispatch_1.default)();
    const onCodeReaded = (0, cameraRenderGetOnQrCallback_1.default)({
        onBarCodeRead,
        onQRCodeRead,
    });
    const cameraMode = (0, react_1.useMemo)(() => {
        if (onTakePicture) {
            return CAMERA_MODE.TAKING_PHOTO;
        }
        if (onStartRecord || onStopRecord) {
            return CAMERA_MODE.RECORDING_VIDEO;
        }
        if (onCodeReaded) {
            return CAMERA_MODE.SCANNING_CODE;
        }
        return CAMERA_MODE.NO_OPTION;
    }, [
        onTakePicture,
        onStartRecord,
        onStopRecord,
        onCodeReaded,
    ]);
    const [cameraState, setCameraState] = (0, react_1.useState)(CAMERA_STATE.READY);
    let actionIcon;
    if (cameraMode === CAMERA_MODE.RECORDING_VIDEO) {
        if (cameraState === CAMERA_STATE.RECORDING) {
            actionIcon = 'video-off';
        }
        else {
            actionIcon = 'video';
        }
    }
    else if (cameraMode === CAMERA_MODE.TAKING_PHOTO) {
        actionIcon = 'camera';
    }
    return (react_1.default.createElement(Render.View, { style: backgroundStyle },
        react_1.default.createElement(Render.View, { style: frameStyle },
            react_1.default.createElement(Render.CameraView, { ref: cameraRef, device: device, style: cameraStyle, zoom: zoom, isTorchOn: isTorchOn, isActive: true, onPermissionRejected: onRejectedPermissions, onZoomChange: setZoom, onCodeReaded: onCodeReaded, onIsTorchOnChange: setIsTorchOn }),
            react_1.default.createElement(Render.View, { style: closeButtonStyle },
                react_1.default.createElement(Render.TouchableOpacity, { onPress: () => {
                        setIsTorchOn(false);
                        setTimeout(() => {
                            dispatch({
                                type: AppStateConstants_1.AppStateConstants.FULL_SCREEN_CAMERA_REQUEST_CLOSE,
                            });
                            onClose === null || onClose === void 0 ? void 0 : onClose();
                        }, 500);
                    } },
                    react_1.default.createElement(Render.SvgIcon, { name: "close", size: 25, color: (isTorchOn) ? '#ffc400' : 'white', family: "FontAwesome" }))),
            react_1.default.createElement(Render.View, { style: containerStyle },
                react_1.default.createElement(Render.TouchableOpacity, { onPress: () => {
                        if (!cameraRef.current) {
                            return;
                        }
                        cameraRef.current.decrementZoom();
                    } },
                    react_1.default.createElement(Render.SvgIcon, { name: "minus", size: 25, color: "white", family: "FontAwesome" })),
                react_1.default.createElement(Render.TouchableOpacity, { onPress: () => {
                        if (!cameraRef.current) {
                            return;
                        }
                        cameraRef.current.incrementZoom();
                    } },
                    react_1.default.createElement(Render.SvgIcon, { name: "plus", size: 25, color: "white", family: "FontAwesome" })),
                actionIcon && (react_1.default.createElement(Render.TouchableOpacity, { onPress: () => {
                        const camera = cameraRef.current;
                        if (!camera) {
                            return;
                        }
                        if (cameraMode === CAMERA_MODE.TAKING_PHOTO) {
                            camera.takePhoto()
                                .then((uri) => {
                                if (onTakePicture) {
                                    onTakePicture(uri);
                                }
                            });
                            return;
                        }
                        if (cameraMode === CAMERA_MODE.RECORDING_VIDEO) {
                            if (cameraState === CAMERA_STATE.RECORDING) {
                                camera.stopRecordingVideo();
                            }
                            else {
                                setCameraState(CAMERA_STATE.RECORDING);
                                camera.startRecordingVideo()
                                    .then((videoUri) => {
                                    setCameraState(CAMERA_STATE.READY);
                                    dispatch({
                                        type: AppStateConstants_1.AppStateConstants
                                            .FULL_SCREEN_CAMERA_REQUEST_CLOSE,
                                    });
                                    if (onStopRecord) {
                                        onStopRecord(videoUri);
                                    }
                                })
                                    .catch(() => {
                                    setCameraState(CAMERA_STATE.READY);
                                });
                            }
                        }
                    } },
                    react_1.default.createElement(Render.SvgIcon, { name: actionIcon, size: 30, color: "white", family: "Feather" }))),
                react_1.default.createElement(Render.TouchableOpacity, { style: cameraState === CAMERA_STATE.RECORDING
                        ? { opacity: 0.2 }
                        : undefined, onPress: () => {
                        if (cameraState === CAMERA_STATE.RECORDING) {
                            return;
                        }
                        setDevice((prev) => (prev === 'back' ? 'front' : 'back'));
                    } },
                    react_1.default.createElement(Render.SvgIcon, { name: "refresh", size: 25, color: "white", family: "FontAwesome" })),
                react_1.default.createElement(Render.TouchableOpacity, { onPress: () => setIsTorchOn((prev) => !prev) },
                    react_1.default.createElement(Render.SvgIcon, { name: "flash", size: 25, color: isTorchOn ? '#ffc400' : 'white', family: "FontAwesome" }))))));
};
exports.default = CameraFullScreenRenderer;
